import { ddsTokens } from '@norges-domstoler/dds-design-tokens';

const coreLightTokens = ddsTokens['core-light'];

const DdsColors = {
  ...coreLightTokens,
  DdsColorDangerBase: coreLightTokens.ddsColorTextDanger,
  DdsColorDangerDark: coreLightTokens.ddsColorIconDanger,
  DdsColorDangerLightest: coreLightTokens.ddsColorSurfaceDangerDefault,
  DdsColorInfoLightest: coreLightTokens.ddsColorSurfaceInfoDefault,
  DdsColorInteractiveBase: coreLightTokens.ddsColorTextActionResting,
  DdsColorInteractiveDarkest: coreLightTokens.ddsColorTextActionHover,
  DdsColorNeutralsGray1: coreLightTokens.ddsColorTextOnInverse,
  DdsColorNeutralsGray7: coreLightTokens.ddsColorTextMedium,
  DdsColorNeutralsGray8: coreLightTokens.ddsColorTextDefault,
  DdsColorNeutralsGray9: coreLightTokens.ddsColorTextDefault,
  DdsColorNeutralsWhite: coreLightTokens.ddsColorSurfaceDefault,
  DdsColorPrimaryBase: coreLightTokens.ddsColorBrandPrimaryDefault,
  DdsColorPrimaryLightest: coreLightTokens.ddsColorBrandPrimarySubtle,
  DdsColorSuccessBase: coreLightTokens.ddsColorIconOnSuccessDefault,
  DdsColorSuccessDark: coreLightTokens.ddsColorIconOnSuccessStrong,
  DdsColorSuccessLightest: coreLightTokens.ddsColorSurfaceSuccessDefault,
};

export const Colors = { ...DdsColors };
